// extracted by mini-css-extract-plugin
export default {"card":"blogSubscribePrompt_card__vau0p","heading":"blogSubscribePrompt_heading__R+sfe","description":"blogSubscribePrompt_description__knx05"};